import {createEventBus} from '@malt/vue-event-bus/create-event-bus';

export type Events = {
    'tab-notification-added': {tabName: string; notificationLabel: string};
    'tab-notification-removed': {tabName: string};
};

export const eventBus = createEventBus<Events>();
